import React from 'react';

import { Box, CircularProgress, List, Typography } from '@mui/material';

import { useGetUserLogsQuery } from '../../../../../common/apis/AdminApi';
import { User } from '../../../../../common/types/User';

import UserLogCell from './components/UserLogCell';

type Props = {
  user: User;
  style?: React.CSSProperties;
};

const UserLogContainer: React.FC<Props> = ({ user, style }) => {
  const { data: userLogs, isLoading: userLogsIsLoading } = useGetUserLogsQuery(
    user.id.toString()
  );

  return (
    <Box
      style={{ ...style, width: '100%', overflow: 'hidden', padding: 0 }}
      className='user-content-container'
    >
      <Typography
        variant='subtitle'
        style={{ display: 'block', margin: '24px' }}
      >
        User log list
      </Typography>
      {userLogsIsLoading ? (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: 24,
            paddingLeft: 24,
            paddingRight: 24,
          }}
        >
          <CircularProgress color='primary' size='32px' />
        </Box>
      ) : (
        <List
          style={{
            paddingTop: '16px',
            paddingBottom: '92px',
            paddingLeft: '20px',
            paddingRight: '20px',
          }}
        >
          {userLogs?.map((userLog) => (
            <UserLogCell key={userLog.id} userLog={userLog} />
          ))}
        </List>
      )}
    </Box>
  );
};

export default UserLogContainer;
